import React from 'react'
import ComingSoon from '../../pages/ComingSoon';

const ProcessFlowChart = () => {
  return (
    <div className=''>
        <ComingSoon />
    </div>
  )
}

export default ProcessFlowChart;
